<section>
  <h6 class="uk-flex uk-flex-middle"><span class="material-symbols-outlined uk-margin-small-right">settings</span>Section settings</h6>
  <div class="uk-margin">
    <div for="sectionName" class="uk-margin-small-bottom uk-text-muted">Section Name *</div>
<!--    <label for="sectionName" class="uk-form-label uk-margin-small-bottom">Section Name *</label>-->
    <div class="uk-form-controls">
      <input id="sectionName" class="uk-input" [ngModel]="$safeNavigationMigration(fbService.currentSubsection()?.name)"
             (ngModelChange)="fbService.setSubSectionName($event)" placeholder="Untitled Section">
    </div>
  </div>
  <div class="uk-margin">
    <div for="sectionDescription" class="uk-margin-small-bottom uk-text-muted">Description *</div>
<!--    <label for="sectionDescription" class="uk-form-label uk-margin-small-bottom">Description *</label>-->
    <div class="uk-form-controls">
      <app-rich-text-editor id="sectionDescription" [ngModel]="$safeNavigationMigration(fbService.currentSubsection()?.description)"
                (ngModelChange)="fbService.setSubSectionDescription($event)"
                placeholder="Give a short description for the section">
      </app-rich-text-editor>
    </div>
  </div>
</section>
